import React, { useEffect } from 'react'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Alert, Button, Flex, Skeleton, Typography } from 'antd'
import { useUnit } from 'effector-react'
import { Link, useParams } from 'react-router-dom'
import { path } from '../../../../libs/path'
import { $wallet, $walletHasError, getWalletFx, walletRequested } from './model'
import { WalletCard } from './WalletCard'

export const WalletGuardWalletDetailsPage = () => {
  const { walletID } = useParams()
  const { wallet, loading, hasError, requestWallet } = useUnit({
    wallet: $wallet,
    loading: getWalletFx.pending,
    hasError: $walletHasError,
    requestWallet: walletRequested,
  })

  const walletId = Number(walletID)
  const hasValidId = Number.isSafeInteger(walletId) && walletId > 0

  useEffect(() => {
    if (hasValidId) requestWallet(walletId)
  }, [requestWallet, walletId, hasValidId])

  const renderContent = () => {
    if (!hasValidId) {
      return (
        <Alert
          type="error"
          showIcon
          message="Некорректный идентификатор кошелька"
        />
      )
    }

    if (hasError) {
      return (
        <Alert
          type="error"
          showIcon
          message="Не удалось загрузить кошелёк"
          action={
            <Button onClick={() => requestWallet(walletId)}>Повторить</Button>
          }
        />
      )
    }

    if (loading || wallet === null) return <Skeleton active />

    return <WalletCard wallet={wallet} />
  }

  return (
    <Flex vertical gap={24}>
      <Flex align="center" gap={12} wrap="wrap">
        <Typography.Title level={1} style={{ margin: 0 }}>
          {wallet?.name || 'Wallet'}
        </Typography.Title>
      </Flex>

      {renderContent()}
    </Flex>
  )
}
